import { Pipe, PipeTransform } from '@angular/core';
import { enumWorkflowTransitionEventType } from '../../utils/models/workflow.model';

@Pipe({
  name: 'workflowTransitionEventType',
})
export class WorkflowTransitionEventTypePipe implements PipeTransform {
  transform(value: enumWorkflowTransitionEventType): string {
    switch (value) {
      case enumWorkflowTransitionEventType.EMAIL:
        return 'Email';
      case enumWorkflowTransitionEventType.INTEGRATION_NOTE:
        return 'Nota integrazione';
      default:
        return '-';
    }
  }
}
